import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import {fetchAutocompleteData} from '@components/form/common/fetch';
import {Input} from '@components/form/Input';
import {empty} from '~/utils/empty';
const merge = require('deepmerge');

export default function RemoteAutocompleteSelect(props) {
    const [url, setUrl] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [errors, setErrors] = React.useState([]);
    const [loading, setLoading] = React.useState(open && options.length === 0);

    const totalErrors = merge(errors, props.errors);
    const {onChange, value, disableClearable = true, disabled = false, groupBy = undefined, fillFirst = false, classWrapperName = '', ...other} = props;
    const multiple = Array.isArray(value);

    const fetchData = async () => {
      setLoading(true);
      setErrors([]);
      const data = await fetchAutocompleteData(url);
      setLoading(false);

      if (typeof data === 'object' && Array.isArray(data.data)) {
        setOptions(data.data);
        if (props.fillFirst && empty(value) && data.data.length > 0) {
          onChange({}, {value: data.data[0].value})
        }
      } else {
        setErrors({[props.name]: ['Failed to fetch source data']});
        setOpen(false);
      }
    }

    React.useEffect(() => {
        (async () => {
            const {url} = props;
            if (url === '') {
              return;
            }

            fetchData();
        })();
    }, [url]);

    if (props.url !== url) {
      setOptions([]);
      setUrl(props.url);
    }

    // fetch option object by provided value_id
    let filteredOptions, optionValue;
    if (multiple) {
        filteredOptions = options.filter((row) => value.indexOf(row.value) !== -1);
        optionValue = filteredOptions
    } else {
        filteredOptions = options.filter((row) => row.value == value);
        optionValue = filteredOptions.length > 0 ? filteredOptions[0] : {};
    }

    return (
        <Autocomplete
            open={open}
            multiple={multiple}
            onOpen={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpen(true);
            }}
            onClose={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpen(false);
            }}
            onChange={onChange}
            value={optionValue}
            getOptionSelected={(option, value) => option.label === value.label}
            getOptionLabel={option => option.label || ''}
            options={options}
            loading={loading}
            groupBy={groupBy}
            disabled={disabled}
            className={classWrapperName}
            renderInput={params => (
                <Input
                    {...params}
                    value={props.value}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    {...other}
                    errors={totalErrors}
                />
            )}
            disableClearable={disableClearable}
            noOptionsText='Ничего не найдено'
            {...other}
        />
    );
}
